export enum HomeFilter {
    ALL = 'ALL',
    OWNED_BY_ME = 'OWNED_BY_ME',
    SHARED_WITH_ME = 'SHARED_WITH_ME',
    SHARED_WITH_GROUP = 'SHARED_WITH_GROUP',
}
